<template>
  <div class="independent-progress">
    <Progress :percent="currentPercent" :strokeColor="barColor" :strokeWidth="8" :showInfo="false" />
  </div>
</template>
<style lang="scss" scoped src="./independent-progress.scss"></style>
<script lang="ts" src="./independent-progress.ts"></script>
